import type { UrlOrganisation } from "components/entry/types";

export type OrganisationsReducer = {
  urlOrganisation: UrlOrganisation | null;
  mobileBannerOpen: boolean;
  demoingTour: string;
  hasSeenIdeaLikeInformationModalThisSession: boolean;
};

export type OrganisationsAction =
  | { type: "RECEIVE_URL_ORGANISATION"; organisation: UrlOrganisation | null }
  | { type: "SET_MOBILE_BANNER_OPEN"; mobileBannerOpen: boolean }
  | { type: "SET_DEMOING_TOUR"; tourId: string }
  | {
      type: "HAS_SEEN_IDEA_LIKE_INFORMATION_MODAL_THIS_SESSION";
      hasSeen: boolean;
    };

const initialState: OrganisationsReducer = {
  urlOrganisation: null,
  mobileBannerOpen: true,
  demoingTour: "",
  hasSeenIdeaLikeInformationModalThisSession: false,
};

function organisations(
  state = initialState,
  action: OrganisationsAction,
): OrganisationsReducer {
  switch (action.type) {
    case "RECEIVE_URL_ORGANISATION":
      return { ...state, urlOrganisation: action.organisation };
    case "SET_MOBILE_BANNER_OPEN":
      return { ...state, mobileBannerOpen: action.mobileBannerOpen };
    case "SET_DEMOING_TOUR":
      return { ...state, demoingTour: action.tourId };
    case "HAS_SEEN_IDEA_LIKE_INFORMATION_MODAL_THIS_SESSION":
      return {
        ...state,
        hasSeenIdeaLikeInformationModalThisSession: action.hasSeen,
      };
    default:
      return state;
  }
}

export default organisations;
